import { type AppHubState, AppHubStateType } from 'src/services/AppHubService';
import { MockAuthenticator } from '../MockAuthenticator';

export function AppQRDebug({ state }: { state?: AppHubState }) {
  let debugUrl: string | undefined = undefined;
  if (state?.type === AppHubStateType.Login && state.qr?.debugUrl) {
    debugUrl = state.qr.debugUrl;
  } else if (state?.type === AppHubStateType.Empty && state.debugUrl) {
    debugUrl = state.debugUrl;
  } else if (state?.type === AppHubStateType.Pending && state.debugUrl) {
    debugUrl = state.debugUrl;
  }
  if (!debugUrl) return null;
  return <MockAuthenticator debugUrl={debugUrl} />;
}
